<template>
  <v-card
    height="100%"
    style="border-width: 0"
  >
    <v-card-title class="primary white--text py-2">
      {{ $t('detail.parent_company_program') }}
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="programs"
      disable-pagination
    >
      <template #[`item.total_views`]="{item}">
        <span>{{ item.total_views - item.active_views }} / {{ item.total_views }} {{ $i18n.locale === 'jp' ? '名' : '' }}</span>
      </template>
      <template #footer.prepend>
        <v-row
          v-if="!loading"
          no-gutters
          class="py-4"
        >
          <v-col
            cols="auto"
            class="text-subtitle-2 pl-2"
          >
            {{ $t('detail.available_corporate') }} :
          </v-col>
          <v-col
            cols="auto"
            class="primary--text text-subtitle-2 pl-2"
          >
            {{ company.max - company.active }} / {{ company.max }} {{ $i18n.locale === 'jp' ? '名' : '' }}
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    programs: {
      type: Array,
      required: true
    },
    company: {
      required: true,
      type: Object
    }
  },
  data () {
    return {

    }
  },
  computed: {
    /**
     * @desc To compute header for the program information of the current parent company
     * */
    headers () {
      return [
        { text: this.$t('detail.name'), align: 'center', divider: true, value: 'title', width: '100px', class: 'font-weight-bold primary--text' },
        { text: this.$t('detail.available'), align: 'center', divider: true, value: 'total_views', width: '100px', class: 'font-weight-bold primary--text' },
      ]
    },
  }
}
</script>
<style scoped>
::v-deep .theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: #212121 !important;
}
::v-deep .v-data-footer__select {
  display: none;
}
::v-deep .v-data-footer__pagination {
  display: none;
}
::v-deep .v-data-footer__icons-before {
  display: none;
}
::v-deep .v-data-footer__icons-after {
  display: none;
}
</style>
